import { Link } from "react-router-dom";
import { Star, ShieldCheck, Clock, IndianRupee, MapPinned, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useContent } from "@/components/site/Layout";

const BADGES = [
  [ShieldCheck, "Trusted Professionals"], [Clock, "Same Day Service"], [IndianRupee, "Transparent Pricing"], [MapPinned, "Service Available Across India"],
];

export const Hero = () => {
  const { data: c = {} } = useContent();
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 grain" aria-hidden />
      <div className="absolute -top-40 -left-32 h-[28rem] w-[28rem] rounded-full bg-primary/15 blur-3xl" aria-hidden />
      <div className="container-x relative pt-10 pb-16 sm:pt-16 lg:pt-20 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-card border border-border px-3 py-1.5 text-sm shadow-sm" data-testid="hero-rating">
            <span className="flex text-amber-400">{[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}</span>
            <span className="font-semibold">5-Star Rated Doorstep Service</span>
          </div>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]" data-testid="hero-headline">
            {c.hero_headline || <>Home Services at <span className="text-primary">Your Doorstep</span></>}
          </h1>
          <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-xl">
            {c.hero_subtext || "Book trusted professionals for repairs, cleaning, installation, maintenance and more."}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild size="lg" className="rounded-full h-12 px-7 text-base shadow-lg shadow-primary/25" data-testid="hero-book-service-button">
              <Link to="/book">Book Service <ArrowRight className="h-4 w-4 ml-1" /></Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full h-12 px-7 text-base border-primary/40 text-primary hover:bg-secondary" data-testid="hero-become-partner-button">
              <Link to="/partner">Become a Partner</Link>
            </Button>
          </div>
          <ul className="mt-8 grid grid-cols-2 gap-3 max-w-lg">
            {BADGES.map(([I, t]) => (
              <li key={t} className="flex items-center gap-2 text-sm font-medium"><span className="h-8 w-8 rounded-lg bg-secondary grid place-items-center"><I className="h-4 w-4 text-primary" /></span>{t}</li>
            ))}
          </ul>
        </div>
        <div className="relative hidden md:block fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="grid grid-cols-5 grid-rows-6 gap-3 h-[520px]">
            <img src="/img/electrician.webp" alt="Onkaal electrician at work" className="col-span-3 row-span-6 h-full w-full object-cover rounded-3xl" fetchPriority="high" />
            <img src="/img/cleaner.webp" alt="Home cleaning professional" className="col-span-2 row-span-3 h-full w-full object-cover rounded-3xl" loading="lazy" />
            <img src="/img/plumber-svc.webp" alt="Plumber fixing a kitchen sink" className="col-span-2 row-span-3 h-full w-full object-cover rounded-3xl" loading="lazy" />
          </div>
          <div className="absolute -bottom-6 -left-6 card-soft p-4 flex items-center gap-3 backdrop-blur-xl bg-card/90" data-testid="hero-inspection-chip">
            <span className="h-11 w-11 rounded-xl bg-primary text-primary-foreground grid place-items-center"><IndianRupee className="h-5 w-5" /></span>
            <div><p className="text-xs text-muted-foreground">Inspection Charge</p><p className="font-display text-xl font-bold">₹199 Only</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};
